import React from 'react';
import WaitingListTab from './WaitingListTab';

export default function PythonTab() {
  const content = (
    <>
      <p>Python Support is still in Beta.</p>
      <p>
        Hud’s Python SDK already powers millions of services daily - ready for you to
        explore.
      </p>
    </>
  );

  return (
    <WaitingListTab
      languageKey="python"
      languageName="Python"
      content={content}
      waitlistText="Join the Beta Program"
    />
  );
}
